import { render, staticRenderFns } from "./TitleArea.vue?vue&type=template&id=711b33b2"
import script from "./TitleArea.vue?vue&type=script&lang=js"
export * from "./TitleArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports